<template>
    <div name="review-modal" class="review-modal">
        <div class="header-bar">
            <img class="back-button" @click="onClose" src="../../../assets/c30/ico-back.png" />
            <span class="header-title">리뷰 확인하기</span>
        </div>
        <div class="reviews" style="margin-top: 142px;">
            <img style="width: 100%;" src="../../../assets/c30/reviews.png" />
        </div>

    </div>
</template>

<script>
export default {
    name: "reviewModal",
    methods: {
        onClose: function()
        {
            this.$emit('onClose');
        }
    }
}
</script>

<style scoped>
    .review-modal {
        width: 100%;
    }
    .header-bar {
        width: 100%;
        max-width: 800px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 126px;
        background: #FFF;
        border-bottom: 16px solid #EFEFEF;
        position: fixed;
    }
    .header-title {
        color: #333;
        font-family: Pretendard;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 52px; /* 130% */
        letter-spacing: -0.8px;
    }
    .back-button {
        position: absolute;
        left: 42px;
        top: 50%;
        transform: translate(0, -50%);
        cursor: pointer;
    }
    .reviews {
        width: 100%;
        padding: 71px 41px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_view/contents/ReviewModal.vue